import * as Form from './styles'
import DatePickerField from './DatePicker'
import FileUploadField from './FileUpload'

export default { ...Form, DatePickerField, FileUploadField }
